import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import parse from "html-react-parser";
import React from "react";
import { css } from "styled-components";

const enum fields {
    description = "description",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.description]: string;
    };
}

type Props = OwnProps;

export interface InfoCardStyles {
    infoCardContainer?: GridContainerProps;
    infoCardDiv?: GridItemProps;
    description?: InjectableCss;
    main?: InjectableCss;
}

export const infoCardStyles: InfoCardStyles = {
    infoCardContainer: {
        css: css`
            margin: 0 auto;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            width: calc(100% + -100px);

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: auto;
                        padding: 0 20px;
                    `,
                    css`
                        width: auto;
                        padding: 0 20px;
                    `,
                    css``,
                ])}
        `,
    },
    infoCardDiv: {
        width: [12, 12],
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 9px 20px;
                        margin-top: 42px !important;
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                    `,
                    css`
                        padding: 9px 20px;
                        margin-top: 42px !important;
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                    `,
                    css`
                        padding: 9px 20px;
                        margin-top: 42px !important;
                        flex-basis: 100% !important;
                        max-width: 100% !important;
                    `,
                    null,
                    null,
                ])}
        `,
    },

    description: {
        css: css`
            p {
                font-size: 14.4px;
                font-style: normal;
                color: ${getColor("primary")};
                font-family: "Roboto-bold";
                text-align: justify;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: -23px;
                    `,
                    css`
                        margin-top: -23px;
                    `,
                    css`
                        margin-top: -23px;
                    `,
                    null,
                    null,
                ])}
        `,
    },

    main: {
        css: css`
            padding-top: 10px;
            background-image: none;
            background-color: #efefef;

            width: calc(100vw - 20px + 6px);
            margin-left: calc(-50vw + 50% + 5px);
            overflow: hidden;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: calc(100vw - 29px + 39px);
                        margin-left: calc(-55vw + 52% + 5px);
                        padding-top: 6px;
                    `,
                    css`
                        width: calc(100vw - 29px + 39px);
                        margin-left: calc(-55vw + 52% + 5px);
                        padding-top: 6px;
                    `,
                    css`
                        width: calc(100vw - 20px + 28px);
                        margin-left: calc(-51vw + 50% + 5px);
                        padding-top: 6px;
                    `,
                    css`
                        width: calc(100vw - -19px + 6px);
                        margin-left: calc(-52vw + 50% + 5px);
                        padding-top: 25px;
                    `,
                    null,
                ])}
        `,
    },
};

const styles = infoCardStyles;

const IconHSection: React.FC<Props> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.main}>
            <GridContainer {...styles.infoCardContainer}>
                <GridItem {...styles.infoCardDiv}>
                    <StyledWrapper className="descClass" {...styles.description}>
                        {parse(fields.description, parserOptions)}
                    </StyledWrapper>
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: IconHSection,
    definition: {
        group: "Basic",
        displayName: "SE Header Content Widget",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.description,
                editorTemplate: "RichTextField",
                displayName: "Description",
                defaultValue: "",
            },
        ],
    },
};

export default widgetModule;
